<template>
  <v-dialog
    v-model="confirmationModal"
    max-width="600"
  >
    <v-card>
      <v-card-title class="subheading">Вы уверены, что хотите выписать резервирование № {{docId}}?</v-card-title>
      <v-card-text>
        <p>Данный документ будет отправлен на склад для сборки заказа.
          После выписки тип и адрес доставки можно будет поменять только через менеджера.</p>
        <v-radio-group v-model="tipDostavki">
          <v-radio label="Самовывоз" value="0"></v-radio>
          <v-radio label="Доставка" value="1"></v-radio>
          <v-radio label="Доставка (регионы)" value="2"></v-radio>
        </v-radio-group>
        <v-textarea
          v-if="tipDostavki > 0"
          v-model="address"
          auto-grow
          name="address"
          id="address"
          label="Адрес доставки"
          rows="1"
        ></v-textarea>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="accent"
          flat="flat"
          @click="confirmationModal = false"
        >
          Нет
        </v-btn>

        <v-btn
          color="accent"
          flat="flat"
          @click="writeoutDocument"
        >
          Да
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'RezervirovanieWriteoutModal',
  data () {
    return {
      confirmationModal: false,
      tipDostavki: '0',
      address: '',
      docId: ''
    }
  },
  methods: {
    open (docId) {
      this.confirmationModal = true
      this.tipDostavki = this.$store.getters['user/tipDostavki']
      this.address = ''
      this.docId = docId
    },
    close () {
      this.confirmationModal = false
    },
    async writeoutDocument () {
      await this.$emit('ok', this.tipDostavki, this.address)
      this.confirmationModal = false
    }
  }
}
</script>

<style scoped>

</style>
